//---------	Global imports
import React from 'react';
//---------	Components
import ProductDetails from '../components/ProductDetails';
import Sidebar from '../components/Sidebar';
import ProductCustomizer from '../components/ProductCustomizer';
import ProductActions from '../components/ProductActions';
import Newsletter from '../components/Newsletter';
import RelatedProducts from '../components/RelatedProducts';
import ProductDescription from '../components/ProductDescription';
//---------	Plugins
import Slider from 'react-slick';
import { forEach, isNumber } from 'lodash';
import { toast } from 'react-toastify';
import { onTemplateLoad } from '../Components/Shared/Commons'
//---------	Translations
import { T } from '../../translations';
//---------  Products List
import productsList from '../pages/shop/productsList.json';
//---------	Styles
import '../css/partials/slider.sass';
import SEO from '../components/SEO/index';


class ProductTemplate extends React.Component {
  
  //---------	Constructor
  constructor(props) {
    super();
    
    this.product = productsList[props.pathContext.path];

    this.gallery = [];
    this.slick = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      customPaging: (i) => {
        return <button><img src={`${this.product.gallery[i + 1]}`}/></button>;
      }
    };
    
    this.zoomedGalleryStyles = {
      height: 0,
      width: 0
    };
    
    this.snipcart = {
      id: this.product.id,
      path: this.product.path,
      thumbnail: this.product.thumbnail,
      name: this.product.name,
      description: this.product.description.short,
      weight: this.product.weight
    };
    
    this.basePrice = this.product.price;
    
    this.state = {
      loading: true,
      fullscreen: false,
      activeGallery: false,
      selectedVariants: this.product.preset,
      currentPrices: [
        this.basePrice,
        this.basePrice
      ],
      itemIsAdding: false,
      secondaryBarMessage: null,
      secondaryBarActive: false
    };
    
    this.goFullScreen = this.goFullScreen.bind(this);
    this.exitFullScreen = this.exitFullScreen.bind(this);
    this.changeVariant = this.changeVariant.bind(this);
    this.updatePrice = this.updatePrice.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.checkSnipcart = this.checkSnipcart.bind(this);
    this.hideSecondaryBar = this.hideSecondaryBar.bind(this);
    this.exitFullScreenEsc = this.exitFullScreenEsc.bind(this);
    this.calcZoomedGallerySize = this.calcZoomedGallerySize.bind(this);
  }
  
  //---------	React functions
  componentDidMount() {
    setTimeout(() => {
      this.galleryFocus();
      this.setState({loading: false})
      onTemplateLoad()
    }, 300);
    this.createGallery();
    this.updatePrice();
    this.checkSnipcart();
    this.calcZoomedGallerySize();
    
    document.addEventListener('keydown', this.exitFullScreenEsc);
    window.addEventListener('resize', this.calcZoomedGallerySize);
  }
  
  componentWillUnmount() {
    document.removeEventListener('keydown', this.exitFullScreenEsc);
    window.removeEventListener('resize', this.calcZoomedGallerySize);
  }
  
  
  //---------	Custom functions
  calcZoomedGallerySize() {
    const isMaxSize = window.innerWidth * .9 > 1000 && window.innerHeight * .9 > 660,
          calcByHeight = isMaxSize || window.innerWidth > window.innerHeight,
          w = calcByHeight ? window.innerHeight * .95 * 1.515 : window.innerWidth * .95,
          h = calcByHeight ? window.innerHeight * .95 : window.innerWidth * .95 * .66;
    
    this.zoomedGalleryStyles = {
      width: `${ isMaxSize ? 1000 : w }px`,
      height: `${ isMaxSize ? 660 : h + 2 }px`
    };
    
    this.forceUpdate()
  }
  
  checkSnipcart() {
    const _this = this;
    if (window.Snipcart) {
      window.Snipcart.subscribe('item.adding', function (item) {
        _this.setState({itemIsAdding: true});
      });
      window.Snipcart.subscribe('item.added', function (item) {
        let basketTotal = window.Snipcart.api.cart.get().total,
            amountToFreeShipping = 150 - basketTotal,
            amountToGift = 250 - basketTotal,
            message = `<p><strong>${item.name}</strong> has been successfully added in to your cart!</p>`;
        
        if(amountToFreeShipping > 0 && amountToGift > 0) {
          message += `<p>If you spend £${amountToFreeShipping} more you'll get <strong>free shipping</strong>, and if you spend £${amountToGift} more you'll get the <strong>special gift</strong>!</p>`
        } else if(amountToFreeShipping <= 0 && amountToGift > 0) {
          message += `<p>You've spend enough to get the <strong>free shipping</strong>! But, if you spend £${amountToGift} more you'll get the <strong>special gift</strong> from us!</p>`
        } else if(amountToFreeShipping <= 0 && amountToGift <= 0) {
          message += `<p>Awesome! You will get the <strong>free shipping</strong> and the <strong>special gift</strong> as well!</p>`
        }
        
        _this.setState({itemIsAdding: false, secondaryBarMessage: message});
        setTimeout(() => _this.setState({secondaryBarActive: true}));
  
        fbq('trackCustom', 'ADD_TO_CART', {
          name: _this.product.name,
          material: _this.state.selectedVariants.material,
          value: _this.state.currentPrices[_this.state.selectedVariants.material === 'premium' ? 0 : 1]
        });
      });
    }
    else {
      setTimeout(this.checkSnipcart, 100);
    }
  }
  
  toggleSidebar(action, details) {
    this.child.toggleSidebar();

    if (action === 'activeTab') {
      this.refs.ProductCustomizer.toggleVariantsList(details, true)
    }
    
    if (action === 'sendToast') {
      toast.info(<div className="filtersApplied info">{T.global.changesApplied}</div>, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500
      });
    }
  
    fbq('trackCustom', 'OPEN_CUSTOMIZER');
  }
  
  createGallery() {
    const gallery = [];
    
    forEach(this.product.gallery, (image, key) => {
      gallery.push(
        <div key={key}>
          <img src={image} alt=""/>
          <a href={'javascript:window.open(\'https://pinterest.com/pin/create/button/?url=' + window.location.href + '&media=' + (window.location.href + image) + '&description=Fully%20customizable%20products%20from%20Merino%20wool%20-%20the%20finest,%20warmest%20and%20softest%20of%20yarn.\', \'_blank\', \'width=400,height=500\');void(0);'}
            className="pinIt"></a>
        </div>
      );
    });
    
    this.gallery = gallery;
  }
  
  goFullScreen() {
    this.setState({fullscreen: true, activeGallery: true}, () => {
      document.body.classList.add('is-fullScreenGallery');
      this.galleryFocus();
    });
  }
  
  exitFullScreen() {
    this.setState({activeGallery: false, fullscreen: false}, () => {
      document.body.classList.remove('is-fullScreenGallery');
    });
  }
  
  galleryFocus() {
    const galleryTrack = document.getElementsByClassName('slick-track')[0];
    galleryTrack.setAttribute('tabindex', 1);
    galleryTrack.focus();
  }
  
  exitFullScreenEsc(e) {
    if(e.keyCode === 27) this.exitFullScreen()
  }
  
  changeVariant(selectedVariants) {
    
    this.setState({selectedVariants: selectedVariants}, this.updatePrice);
    
    if (window.innerWidth >= 768) {
      toast.info(<div className="filtersApplied info">{T.global.changesApplied}</div>, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500
      });
    }
  }
  
  updatePrice() {
    const selectedVariants = this.state.selectedVariants,
      variants = this.product.variants;
    
    let selectedVariant,
      price,
      prices = [this.basePrice, this.basePrice];
    
    for(let i=0;i<=1;i++){
      forEach(this.product.variants, (options, name) => {
        selectedVariant = selectedVariants[name];
        price = variants[name][selectedVariant];
        price = isNumber(price) ? price : parseInt(price.split('|')[i]);
  
        prices[i] += price;
      });
    }
    this.setState({currentPrices: prices});
  }
  
  hideSecondaryBar(openCart) {
    this.setState({secondaryBarActive: false});
    setTimeout(() => this.setState({secondaryBarMessage: null}), 500);
    
    if (openCart) {
      window.Snipcart.api.modal.show();
    }
  }
  
  
  
  
  
  //---------	Render
  render() {
    const seo = {
      title: this.product.name + ' | Calipsy',
      image: this.product.thumbnail,
      description: this.product.description.short
    };
    
    let galleryClass = 'CalipsySlider',
      zoomedGalleryStyles = {};
    
    if (this.state.fullscreen){
      galleryClass += ' is-fullscreen';
      zoomedGalleryStyles = this.zoomedGalleryStyles;
    }
    if (this.state.activeGallery) galleryClass += ' is-active';
    
    return (
      <div className={this.state.loading ? 'CalipsyWrapper CalipsyWrapper-loading' : 'CalipsyWrapper'}>
        
        <SEO {...seo}/>
        
        <div className="CalipsySpinner"></div>
        
        {
          this.state.secondaryBarMessage ? (
            <div className={this.state.secondaryBarActive ? 'CalipsySecondaryBar is-active' : 'CalipsySecondaryBar'}>
              <div className="CalipsyContainer">
                <div dangerouslySetInnerHTML={{__html: this.state.secondaryBarMessage}}></div>
                <div className="CalipsySecondaryBar-actions">
                  <button className="CalipsyButton" onClick={() => this.hideSecondaryBar(true)}>See cart</button>
                  <button className="CalipsyButton" onClick={() => this.hideSecondaryBar()}>Continue shopping</button>
                </div>
              </div>
            </div>
          ) : null
        }
        
        <div className="CalipsyWrapper-container">
          <div className="CalipsyProduct">
            <div className="CalipsyContainer">
              
              <h1>{this.product.name}</h1>
              
              <div id="slider" className={galleryClass}>
                <div className='CalipsySlider-container'>
                  <div className="CalipsySlider-outer">
                    <div className="CalipsySlider-inner" style={zoomedGalleryStyles}>
                      {this.gallery.length ? <Slider {...this.slick}>{this.gallery}</Slider> : null}
                      <button className="CalipsySlider-fullscreen"><span onClick={() => this.state.fullscreen ? this.exitFullScreen() : this.goFullScreen()}>zoom</span></button>
                    </div>
                  </div>
                </div>
              </div>
              
              <ProductDetails
                toggleSidebar={(action, tab) => this.toggleSidebar(action, tab)} {...this.state.selectedVariants} />
              
              <ProductActions snipcart={this.snipcart} variants={this.product.variants}
                              selectedVariants={this.state.selectedVariants}
                              basePrice={this.basePrice}
                              currentPrices={this.state.currentPrices}
                              itemIsAdding={this.state.itemIsAdding}
                              toggleSidebar={() => this.toggleSidebar('activeTab', '')}
                              upgrade={selectedVariants => this.changeVariant(selectedVariants)}/>
              
              <ProductDescription description={this.product.description.long}/>
              
            
            </div>
            
            <RelatedProducts alternate="true" title={T.relatedProducts.titleOnProductPage}/>
            
            <Newsletter alternate="true"/>
          </div>
        </div>
        
        <Sidebar onRef={ref => (this.child = ref)} title={T.product.customizerTitle}>
          <ProductCustomizer toggleSidebar={this.toggleSidebar}
                             ref='ProductCustomizer'
                             changeVariant={selectedVariants => this.changeVariant(selectedVariants)}
                             productType={this.product.type}
                             variants={this.product.variants} selectedVariants={this.state.selectedVariants}/>
        </Sidebar>
      </div>
    );
  }
}

export default ProductTemplate;


// WEBPACK FOOTER //
// ./src/templates/product.js